export default function ExportOptionsModalController($uibModalInstance, exportOptions, gettextCatalog) {
  'ngInject';
  const ctrl = this;

  ctrl.exportOptions = [{ label: gettextCatalog.getString('Select an Option'), value: '' },  ...exportOptions];
  if (exportOptions?.length > 1) {
    ctrl.exportOptions.push({ label: gettextCatalog.getString('Export All'), value: '__all__' });
  }
  
  ctrl.selectedOption = ctrl.exportOptions[0];

  ctrl.export = () => {

    if (ctrl.selectedOption?.value !== '') {
      $uibModalInstance.close(ctrl.selectedOption);
    }
  }

  ctrl.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  }
}
